var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cog-layout"},[_c('aside',{class:['cog-sidebar-shell', _vm.showclass]},[_c('leftnav')],1),_vm._v(" "),_c('div',{staticClass:"cog-main-shell"},[_c('header',{staticClass:"cog-header"},[_c('navcon')],1),_vm._v(" "),_c('main',{staticClass:"cog-page-shell"},[_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d18696a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = null
// module chunks = 